import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import styled from 'styled-components';
import {LoadingIndicator, LOADING_MESSAGE, List, Typography} from '@fupa/fupa-uikit';
import ProfileStatisticsRow from 'app/components/profile/ProfileStatisticsRow';
import {Helmet} from 'react-helmet-async';
import {func, string} from 'prop-types';
import {fetchRefereeGroupHistory} from 'app/routes/refereeGroup/RefereeGroupPageActions';
import {RefereeGroupHistoryPageReducer} from 'app/routes/refereeGroup/RefereeGroupPageReducer';
import {useInfiniteScrollComponentState} from 'app/hooks/useInfiniteScroll';
import {StreamPlaceholder} from 'app/styles/stream';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const RefereeCaption = styled(Typography)`
  flex: 1 10%;
  text-align: center;
`;

const RefereeCaptionLong = styled(Typography)`
  flex: 1 50%;
  text-align: left;
`;

const RefereeGroupHistoryPage = ({updateRefereeGroupPageState, defaultMetaDescription, dispatchRedux}) => {
  const {restoredData} = useRestoreData('RefereeGroupHistoryPage');
  const {groupSlug} = useParams();
  const initialState = restoredData ?? {
    isFetching: false,
    items: [],
    nextUrl: '',
    error: null,
  };
  const [state, dispatch] = useReducer(RefereeGroupHistoryPageReducer, initialState);

  const loadData = reloading =>
    fetchRefereeGroupHistory(groupSlug, updateRefereeGroupPageState, reloading, dispatchRedux)(dispatch, state);
  const {items, isFetching, error} = state;
  useInfiniteScrollComponentState(loadData, items.length);
  useFetchData(state, loadData, 'RefereeGroupHistoryPage');

  const title = 'Chronik - ';
  const meta = [{name: 'description', content: `${title}${defaultMetaDescription}`}];

  const referees = items.map((referee, index) => (
    <ProfileStatisticsRow
      key={referee.slug}
      profile={referee}
      statistics={referee}
      rank={index + 1}
      rows={['matches', 'yellowCards', 'yellowRedCards', 'redCards']}
      profileType='referee'
    />
  ));

  const showLoading =
    isFetching && !error ? (
      <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor={false} />
    ) : error ? (
      <StreamPlaceholder>Beim Laden ist ein Fehler aufgetreten.</StreamPlaceholder>
    ) : null;

  return (
    <ContentAdDesktop top='7.125rem'>
      <Helmet title={title} meta={meta} />
      <List>
        <RefereeCaption variant='caption1'>Pl.</RefereeCaption>
        <RefereeCaptionLong variant='caption1'>Schiedsrichter</RefereeCaptionLong>
        <RefereeCaption variant='caption1'>Sp.</RefereeCaption>
        <RefereeCaption variant='caption1'>G</RefereeCaption>
        <RefereeCaption variant='caption1'>G-R</RefereeCaption>
        <RefereeCaption variant='caption1'>R</RefereeCaption>
      </List>
      {referees}
      {showLoading}
    </ContentAdDesktop>
  );
};

RefereeGroupHistoryPage.propTypes = {
  updateRefereeGroupPageState: func.isRequired,
  defaultMetaDescription: string.isRequired,
};

export default RefereeGroupHistoryPage;
